import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import doc                       from '@widesk-core/decorators/doc';
import model                     from '@widesk-core/decorators/model';
import TimestampAble             from '@widesk-core/models/traits/TimestampAble';
import Blamable                  from '@/models/traits/Blamable';
import Translatable              from '@widesk-core/models/traits/Translatable';
import WebsiteEntertainmentModel from './WebsiteEntertainmentModel';
import ParticipationStatusModel  from './ParticipationStatusModel';
import { RenderNameProps }       from '@widesk-ui/mixins/ApiModelRenderName';

// Ecrit manuellement
@model.urnResource('participation')
@doc.path('/participations/{?id}')
export default class ParticipationModel extends Blamable(TimestampAble(Translatable(WebsiteServiceModel, {
	'title': true,
	'excerpt': true,
}))) {
	declare protected _tsFilters: {
		'partial': string;
		'participationStatus': string;
		'slug': id;
		'websiteEntertainment': id;
		'websiteEntertainment.website': id;
		'search': string;
	};

	declare private _tsSorts: {
		'id': string;
		'figure.name': string;
		'position': string;
		'createdAt': string;
		'updatedAt': string;
		'publishedAt': string;
	};

	@doc.model(WebsiteEntertainmentModel) declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.model(ParticipationStatusModel) declare participationStatus: ParticipationStatusModel;
	@doc.string declare slug: string;
	@doc.number declare position: number;

	public renderName(props?: RenderNameProps<this> & ParticipationNameProps) {
		return super.renderName(props);
	}
}
